export const listTasks = /* GraphQL */ `
  query ListTasks {
    listTasks {
      items {
        id title client assignee due status priority team createdAt updatedAt
      }
    }
  }
`;

export const listContacts = /* GraphQL */ `
  query ListContacts(
    $filter: ModelContactFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContacts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id name email company phone role tags createdAt updatedAt
      }
      nextToken
    }
  }
`;